<template>
    <ul class="text-sm leading-tight space-y-2 divide-grey-dark sm:inline-flex sm:space-y-0 sm:space-x-4 sm:divide-x">
        <li v-for="(item, i) in items" :class="{'sm:pl-4': i>0}">
            <inertia-link v-if="item.href"
                          :data="item.data"
                          :href="item.href"
                          :only="item.only"
                          :preserveScroll="item.preserveScroll"
                          :preserveState="item.preserveState"
                          :replace="item.replace">
                {{ item.label }}
                <span v-if="item.suffix" class="text-grey-darker hover:text-grey-darker" v-text="item.suffix"/>
            </inertia-link>
            <template v-else>
                <span class="text-primary">{{ item.label }}</span> {{ item.suffix }}
            </template>
        </li>
    </ul>
</template>

<script>

let defaultItem = {
    label: '',
    suffix: '',
    data: {},
    href: '',
    replace: false,
    preserveScroll: false,
    preserveState: false,
    only: [],
};

export default {

    props: {
        breadcrumbs: {
            type: Array,
            required: true,
        }
    },

    computed: {
        items() {
            return this.breadcrumbs.map(item => Object.assign({}, defaultItem, item));
        },
    }
};

</script>
